import angular from 'angular';

let VaccineDetailController = function ($filter, $mdDialog, $scope, $state, Target, Toast, Vaccine) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.vaccine;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,
    isIdInList,
    toggleItemInList
  });

  activate();

  function activate() {
    clearForm();

    loadDomainResources()
      .then(result => {
        let targetGroups = result[0];
        buildCheckboxSections(targetGroups);
        loadResource($ctrl.id);
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function clearForm(form) {
    $ctrl.vaccine = {
      target_groups: []
    };

    if (form) {
      form.$setPristine(); 
      form.$setUntouched();
    }
  }

  function handleDelete(vaccine, event) {
    let confirmMessage = 'vaccine-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Vaccine
          .destroy(vaccine)
          .then(response => {
            Toast.success($filter('translate')('vaccine-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('vaccine.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, vaccine) {
    if (!form.$valid || !vaccine.target_groups.length) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    save(vaccine);
  }

  function isIdInList(list, id) {
    return _.find(list, {id: id});
  }

  function toggleItemInList(list, item) {
    if (_.find(list, {id: item.id})) {
      _.remove(list, {id: item.id});
    } else {
      list.push(item);
    }
  }

  // Local functions
  function loadResource(id){
    if (id) {
      $ctrl.uiState = 'LOADING';

      Vaccine.show(id)
        .then(response => {
          $ctrl.vaccine = response;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
      $scope.$apply();
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Target.index({limit: 1000000, parent_group_id: 'null'}));

    return Promise.all(promises);
  }

  function buildCheckboxSections(topLevelGroups) {
    _.forEach(topLevelGroups, topLevelGroup => {
      let bottomLevelGroups = [];

      _.forEach(topLevelGroup.sub_groups, subGroup => {
        if(_.isEmpty(subGroup.sub_groups)) {
          bottomLevelGroups.push(subGroup);
        } else {
          _.forEach(subGroup.sub_groups, bottomLevelGroup => {
            bottomLevelGroup.name = bottomLevelGroup.name + ' (' + subGroup.name + ')';
            bottomLevelGroups.push(bottomLevelGroup);
          });
        }
      });

      topLevelGroup.bottomLevelGroups = bottomLevelGroups;
    });

    $ctrl.topLevelGroups = topLevelGroups;
  }

  function save(vaccine) {
    $ctrl.saving = true;

    Vaccine
      .save(vaccine)
      .then(response => {
        Toast.success($filter('translate')('vaccine-detail-save-success'));
        $ctrl.vaccine = response;
        $state.go('vaccine.list');
      })
      .catch(err => {
        let defaultErrMsg = $filter('translate')('common-server-error');
        let fourONineMsg = $filter('translate')('vaccine-detail-409-error') 
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error(message);
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }
}

VaccineDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Target', 'Toast', 'Vaccine'];

export default VaccineDetailController;


// WEBPACK FOOTER //
// ./client/app/components/vaccine/vaccine-detail.controller.js